import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './app/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react'
import { persistStore } from 'reduxjs-toolkit-persist'

let persistor = persistStore(store)

window.onload = function () {
  let path = window.location.pathname;
  if (!localStorage.hasOwnProperty("access_token") ||
    localStorage.access_token === "") {
    if (!path.includes("")) {
      window.location.href = "/";
    }
  } else {
    if (!path.includes(localStorage.userrole)) {
      window.location.href = "/" + localStorage.userrole + "/"+"dashboard";
    }
  }
}


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
        <App />
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
